import { useEffect } from 'react';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import AgentsList from '@aviv-estimation-funnel/shells/micro-front-end/AgentsList';
import ProfiCard from '@aviv-estimation-funnel/shells/micro-front-end/ProfiCard';
import Footer from '@aviv-estimation-funnel/shells/src/app/components/Footer';
import { preloadSvgSprite } from '@aviv-estimation-funnel/shells/src/app/helpers/headScript';
import { ImmoWeltLogo } from '@aviv-estimation-funnel/shells/src/app/portals/immowelt/assets/svg/ImmoWeltLogo';
import { IWT_THEME } from '@gemini/tokens';
import Wlef from '@mfe/remote-entry';
import apartmentAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/apartment.json';
import blockedViewAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/blocked-view.json';
import calculationCompleteAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/calculation-complete.json';
import calculationProgressAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/calculation-progress.json';
import clearViewAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/clear-view.json';
import confettisAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/confettis.json';
import fourFacadesAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/four-facades.json';
import houseAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/house.json';
import individualAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/individual.json';
import outstandingViewAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/outstanding-view.json';
import professionalAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/professional.json';
import shieldAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/shield.json';
import threeFacadesAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/three-facades.json';
import twoFacadesAnimation from '@mfe-presentation/assets/lottie/portals/immowelt/two-facades.json';
import { BrowserRouter } from 'react-router-dom';

import { ShellProps, ShellProvider, useShellContext } from '../../factory';
import TrackingService from '../../helpers/tracking';

import { locale } from './i18nConfig';
import { immoweltFrontConfiguration } from './immoweltFrontConfig';

const IWTShell = () => {
    const clearTracking = TrackingService.initTracking();

    useEffect(() => {
        return () => clearTracking();
    }, []);

    useEffect(() => {
        preloadSvgSprite();
    });

    const shellProps: ShellProps = {
        mfes: {
            agentsList: AgentsList,
            profiCard: ProfiCard,
        },
        theme: IWT_THEME,
        locale,
        portal: Portal.ImmoWelt,
        animations: {
            apartment: apartmentAnimation,
            house: houseAnimation,
            individual: individualAnimation,
            professional: professionalAnimation,
            twoFacades: twoFacadesAnimation,
            threeFacades: threeFacadesAnimation,
            fourFacades: fourFacadesAnimation,
            blockedView: blockedViewAnimation,
            clearView: clearViewAnimation,
            outstandingView: outstandingViewAnimation,
            shield: shieldAnimation,
            calculationComplete: calculationCompleteAnimation,
            calculationProgress: calculationProgressAnimation,
            confettis: confettisAnimation,
        },
    };

    return (
        <ShellProvider {...shellProps}>
            <BrowserRouter basename={process.env.NX_BASE_URL}>
                <Wlef
                    portal={Portal.ImmoWelt}
                    logo={ImmoWeltLogo}
                    config={immoweltFrontConfiguration.steps}
                    useShellContext={useShellContext}
                />
            </BrowserRouter>
            <Footer {...immoweltFrontConfiguration.footer} portal={Portal.ImmoWelt} />
        </ShellProvider>
    );
};

export default IWTShell;
